import { createSlice } from "@reduxjs/toolkit";
import restaurantContractApi from "./api";
import { toast } from "react-toastify";

const initialState = {
  restaurantContracts: [],
  pagination: { current: 1, pageSize: 10 },
  isLoading: false,
  isProcessing: false,
  isCompleted: false,
};

export const restaurantContractSlice = createSlice({
  name: "restaurantContract",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsProcessing: (state, action) => {
      if (action.payload === true) state.isCompleted = false;
      state.isProcessing = action.payload;
    },
    setIsCompleted: (state, action) => {
      state.isCompleted = action.payload;
    },
    setRestaurantContracts: (state, action) => {
      state.restaurantContracts = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    editRestaurantContract: (state, action) => {
      state.isCompleted = true;
      state.restaurantContracts = state.restaurantContracts.map((contract) =>
        contract._id === action.payload._id ? action.payload : contract
      );
    },
    removeRestaurantContract: (state, action) => {
      state.isCompleted = true;
      state.restaurantContracts = state.restaurantContracts.filter(
        (contract) => contract._id !== action.payload
      );
    },
  },
});

export const {
  setIsLoading,
  setIsCompleted,
  setIsProcessing,
  setRestaurantContracts,
  setPagination,
  editRestaurantContract,
  removeRestaurantContract,
} = restaurantContractSlice.actions;

export const fetchRestaurantContracts = (params) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await restaurantContractApi.getAll(params);
      dispatch(setRestaurantContracts(data.data));
      dispatch(setPagination(data.meta));
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi tải danh sách hợp đồng!");
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};

export const verifyRestaurantContract = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantContractApi.verify(id);
      if (data.error) {
        toast.error(data.error.msg || "Lỗi khi xác minh hợp đồng!");
      } else {
        dispatch(editRestaurantContract(data));
        toast.success("Xác minh hợp đồng thành công!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi xác minh hợp đồng!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const rejectRestaurantContract = (id, reason) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantContractApi.reject(id, reason);
      if (data.error) {
        toast.error(data.error.msg || "Lỗi khi từ chối hợp đồng!");
      } else {
        dispatch(editRestaurantContract(data));
        toast.success("Từ chối hợp đồng thành công!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi từ chối hợp đồng!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const deleteRestaurantContract = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantContractApi.delete(id);
      if (data.success) {
        dispatch(removeRestaurantContract(id));
        toast.success("Xóa hợp đồng thành công!");
      } else {
        toast.error("Lỗi hệ thống, xóa hợp đồng thất bại!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi xóa hợp đồng!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export default restaurantContractSlice.reducer;
